import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { DivisionInfo } from '../../model/division.model';


@Component({
  selector: 'app-division',
  templateUrl: './division.component.html',
  styleUrls: ['./division.component.css']
})
export class DivisionComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
  _PositionModule: number;
   
  LoadDivision: DivisionInfo[]; 
  txtSchDivisionName: string;
  txtSchDivisionCode: string;
  ddlSchPositionStatus: string;
  txtDivisionCode: string;
  txtDivisionName: string;
  isOnUpdate: boolean;
  hidDivisionId: number;
  element: HTMLElement;
  public hidcouchk: string;
  IsDuplicateCode: boolean = false;
  IsSubmitted: boolean = false;

  //Form variable
  positionForm: FormGroup;
  positionInfo: DivisionInfo = new DivisionInfo;

  //Pagination
  currentPageNumber: number = 1;
  totalDivisions: number = 0;
  totalPages: number = 0;
  pageSize: number;
  public DivisionTotal: any
  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

    // Zone pagination variable
  isSubmitted: any;
  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeSmall;
    this._EmpCode = localStorage.getItem("EmpCode");
    this._PositionModule = ConstVariable.PositionProjectModule; //Project Delivery
    this.ddlSchPositionStatus = ''
    this.LoadListDivision();
    this.LoadCountDivision();
   

    //Load init data
    
    
     

    //Declare form
    this.positionForm = new FormGroup({
      //PositionCode: new FormControl(this.positionInfo.PositionCode, [Validators.required]),
      //PositionName: new FormControl(this.positionInfo.PositionName, [Validators.required]),
      //PositionLevel: new FormControl(this.positionInfo.PositionLevel, [Validators.required]),
      //PositionStatus: new FormControl(this.positionInfo.FlagActive),
      //FlagCreate: new FormControl(this.positionInfo.FlagCreate),
      //FlagEdit: new FormControl(this.positionInfo.FlagEdit),
      //FlagDeleteRights: new FormControl(this.positionInfo.FlagDeleteRights),
      //FlagApprove: new FormControl(this.positionInfo.FlagApprove),
      //FlagAssign: new FormControl(this.positionInfo.FlagAssign),
      //FlagView: new FormControl(this.positionInfo.FlagView),
    });
  }

  //get PositionCode() { return this.positionForm.get('PositionCode'); }
  //get PositionName() { return this.positionForm.get('PositionName'); }
  //get PositionLevel() { return this.positionForm.get('PositionLevel'); }

   
  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }


  async LoadListDivision(positionId: number = 0){
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['DivisionName'] = this.checkUndefinedString(this.txtSchDivisionName);
      objectjson['DivisionCode'] = this.checkUndefinedString(this.txtSchDivisionCode);
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<DivisionInfo[]>(this.baseurl + "Division/GetDivision", strjson, httpOptions)
        .toPromise()
        .then(data => {
          this.LoadDivision = data
        });
    }
  }
  async LoadCountDivision() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['DivisionName'] = this.checkUndefinedString(this.txtSchDivisionName);
      objectjson['DivisionCode'] = this.checkUndefinedString(this.txtSchDivisionCode);
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<number>(this.baseurl + "Division/GetCountDivision",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.SetTotalpagePagination(data)
        });
    }
  }


  
  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.LoadListDivision();
   
  }
  OnClear_Click() {
    this.txtSchDivisionName = null;
    this.txtSchDivisionCode = null;
    this.txtDivisionName = null;
    this.txtDivisionCode = null; 

    this.currentPageNumber = 1;
    this.LoadListDivision();
  }

  //Create btn
  btnClick_onCreateDivision() {
    this.txtDivisionCode = "";
    this.txtDivisionName = "";
    this.isOnUpdate = false;
    this.IsSubmitted = false;
    //$('#InsertSectionDivision').css('display', 'block');
    $('#modalCreateOrEditDivision').modal();
  }
  btnClick_cancel() {
    this.txtSchDivisionName = null;
    this.txtSchDivisionCode = null;
    this.txtDivisionName = null;
    this.txtDivisionCode = null; 
    //$('#InsertSectionDivision').css('display', 'none');
    $('#modalCreateOrEditDivision').modal('hide');
  }


  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitlookup").hide();
      $("#txtLookupType").prop('disabled', true);
      $("#txtLookupValue").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitlookup").show();
      $("#txtLookupType").removeAttr('disabled');
      $("#txtLookupValue").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalLookup').modal('hide');
    }
  }


  async btnClick_submitInsertDivision() {
    this.IsSubmitted = true;

    if (!this.txtDivisionCode)
      return;

    if (!this.txtDivisionName)
      return;

    if (this.IsDuplicateCode)
      return;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.OnCreating('y');
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };



      let strjson = "{" +
        "\"DivisionCode\": \"" + this.checkUndefinedString(this.txtDivisionCode) + "\", " +
        "\"DivisionName\": \"" + this.checkUndefinedString(this.txtDivisionName) + "\", " +
        "\"CreateBy\": \"" + this.checkUndefinedString(localStorage.getItem("EmpCode")) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";

      this.isSubmitted = this.httpClient.post<LookupInfo[]>(this.baseurl + "Division/InsertDivision", strjson, httpOptions)

        .subscribe(result => this.isSubmitted = result, failCb => {
          console.log("Insert fail")
          this.OnCreating('n');
        },
          () => {
            console.log("Insert = " + this.isSubmitted)
            this.OnClear_Click();
            //this.AuthorizeUser(this.ddlCompany + "0" + this.txtExEmpCode);

            //Inform user
            this.titlemodal = '';
            this.detailmodal = 'Division has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            //$('#InsertSectionDivision').css('display', 'none');
            $('#modalCreateOrEditDivision').modal('hide');
            this.LoadListDivision();
            this.LoadCountDivision();
          }
        );
    }
  }

  //Edit Function
  OnEdit_Click(id) {
    //$('#InsertSectionDivision').css('display', 'block');
   //document.getElementById("AddEditDivision").scrollIntoView();
    this.isOnUpdate = true

    let index = this.LoadDivision.findIndex(x => x.DivisionId == id);  
    this.hidDivisionId = this.LoadDivision[index].DivisionId
    this.txtDivisionCode = this.LoadDivision[index].DivisionCode
    this.txtDivisionName = this.LoadDivision[index].DivisionName
    $('#modalCreateOrEditDivision').modal();

    
  }
  btnClick_submitUpdateDivision(id) {
    this.IsSubmitted = false;
    $('#ModalConfirmChanges').modal();
  }
  async confirmSaveChanges() {
    this.IsSubmitted = true;

    if (!this.txtDivisionCode)
      return;

    if (!this.txtDivisionName)
      return;

    if (this.IsDuplicateCode)
      return;

    $('#ModalConfirmChanges').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      //$('#InsertSectionDivision').css('display', 'block');
      var id = this.hidDivisionId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      if (this.txtDivisionName == undefined || this.txtDivisionName == null || this.txtDivisionName == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }

      else if (this.txtDivisionCode == undefined || this.txtDivisionCode == null || this.txtDivisionCode == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
      else {

        let objData = {};
        objData["DivisionId"] = id;
        objData["DivisionCode"] = this.txtDivisionCode;
        objData["DivisionName"] = this.txtDivisionName;
        objData["UpdateBy"] = this.checkUndefinedString(localStorage.getItem("EmpCode")); 
        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<DivisionInfo[]>(this.baseurl + "Division/UpdatDivision", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();
              //$('#InsertSectionDivision').css('display', 'none');

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditDivision').modal('hide');

              //Load new data
              this.LoadListDivision();
              this.LoadCountDivision();
            }
          )
      }
    }
  }
   

 //Delete Function
  async OnDelete_Click(id) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{DivisionId: " + id + "}";

      if (confirm("Are you sure you want to delete this Division?")) {
        this.isSubmitted = this.httpClient.post<DivisionInfo[]>(this.baseurl + "Division/DeleteDivision", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.OnClear_Click();

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Division information has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LoadListDivision();
              this.LoadCountDivision();
            }
          )
      }
    }

  }
 
  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxDivision"]').prop('checked', check);

  }

  async OnDeleteList_Click() {
    let num = parseInt(this.hidcouchk);
    for (var i = 0; i < num; i++) {
      var element = <HTMLInputElement>document.getElementById('chk' + i);
      var isChecked = element.checked;

      var element2 = <HTMLInputElement>document.getElementById('DivisionId' +i);

      if (isChecked) {
        await this.OnDelete_Click(parseInt(element.value));
      }
    }
    //Load new data
    this.LoadListDivision();
    this.LoadCountDivision();
  }

  //Name position clicked
  OnAddRights_Click(id) {

  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
    }

    this.LoadListDivision();
  }
  SetTotalpagePagination(data) {
    this.totalDivisions = data;
    if (this.totalDivisions == 0) this.currentPageNumber = 0;
    this.totalPages = Math.ceil(this.totalDivisions / environment.PageSize);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  async CheckDuplicateCode() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['DivisionCode'] = this.txtDivisionCode;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "Division/CheckDuplicateDivisionManagementCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }
}
